import React, { useState, useEffect } from 'react';

export default function ScrollUpButton({ color = '#000' }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.pageYOffset > 300);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const scrollToTop = e => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (!visible) return null;

    return (
        <a
            href="#"
            className="scrollup"
            onClick={scrollToTop}
            style={{ display: "inline", color, width: "64px", height: "64px" }}
        >
            <img src={"/assets/img/icons/up-arrow.png"} alt="Yukarı" />
        </a>
    );
}
